// extracted by mini-css-extract-plugin
export default {"button":"FilesForm_button__2kn2L","group":"FilesForm_group__htc4H","PinIcon":"FilesForm_PinIcon__DmBVu"};